import React from 'react'
import BrandsListContainer from './BrandsListContainer'

const BrandsList = () => <BrandsListContainer data-test="component-brands-list" />

export default BrandsList
